function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3257 0H3.67536C3.39137 0 3.16113 0.269559 3.16113 0.602052V4.21437C3.16113 4.54686 3.39137 4.81642 3.67536 4.81642H12.3257C12.6097 4.81642 12.8399 4.54686 12.8399 4.21437V0.602052C12.8399 0.269519 12.6097 0 12.3257 0Z",
  fill: "#00A32C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00056 0H3.67536C3.39137 0 3.16113 0.269559 3.16113 0.602052V4.21437C3.16113 4.54686 3.39137 4.81642 3.67536 4.81642H8.00056V0Z",
  fill: "#00E03B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1024 1.56638L12.5566 0.0644179C12.4296 -0.0104373 12.2819 -0.0204715 12.1483 0.0367235C12.0148 0.0939586 11.9075 0.213366 11.8519 0.366528L8 10.9754L4.1481 0.366528C4.0925 0.213366 3.98516 0.0939586 3.8517 0.0367235C3.71814 -0.0205117 3.57038 -0.0105176 3.44347 0.0644179L0.897585 1.56634C0.112561 2.02952 -0.216409 3.12569 0.148695 4.06185L3.76397 13.3333H6.62776H12.236L15.8513 4.06189C16.2164 3.12569 15.8875 2.02952 15.1024 1.56638Z",
  fill: "#00E03B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8 10.9754L4.1481 0.366528C4.0925 0.213366 3.98516 0.0939586 3.8517 0.0367235C3.71814 -0.0205117 3.57038 -0.0105176 3.44347 0.0644179L0.897586 1.56634C0.112562 2.02952 -0.216409 3.12569 0.148695 4.06185L3.76397 13.3333H8V10.9754Z",
  fill: "#82FAA2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.0002 10C5.35346 10 3.2002 12.243 3.2002 15C3.2002 17.757 5.35346 20 8.0002 20C10.6469 20 12.8002 17.757 12.8002 15C12.8002 12.243 10.6469 10 8.0002 10Z",
  fill: "#E0B700"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.4085 13.2382L8.5862 13.8307C8.6437 14.0223 8.80858 14.1521 8.99462 14.1521H9.56973C9.98575 14.1521 10.1587 14.7287 9.82214 14.9936L9.35686 15.3598C9.20636 15.4782 9.14335 15.6882 9.20086 15.8799L9.37856 16.4724C9.50713 16.9009 9.05428 17.2573 8.71771 16.9925L8.25243 16.6263C8.10192 16.5078 7.89808 16.5078 7.74757 16.6263L7.28229 16.9925C6.94572 17.2573 6.4929 16.901 6.62144 16.4724L6.79914 15.8799C6.85665 15.6882 6.79364 15.4782 6.64314 15.3598L6.17786 14.9936C5.84128 14.7287 6.01425 14.1521 6.43027 14.1521H7.00538C7.19142 14.1521 7.35633 14.0223 7.4138 13.8307L7.5915 13.2382C7.72017 12.8096 8.27993 12.8096 8.4085 13.2382Z",
  fill: "#FFFBE6"
});

var SvgBestPlayer = function SvgBestPlayer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBestPlayer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bestPlayer.dad650de.svg";
export { ForwardRef as ReactComponent };